import { GET_DELIVERY_AGENTS_BY_ID_DATA_LOADING, GET_DELIVERY_AGENTS_BY_ID_DATA_SUCCESS, GET_DELIVERY_AGENTS_BY_ID__DATA_ERROR, RESET_GET_DELIVERY_BY_ID_AGENTS_DATA_SUCCESS } from "../type/Constant";

let initialState = {
  getDeliveryAgentsById: {
    loading: false,
    data: null,
    error: false,
    errors: null,
    success: false
  },
};

export default function getDeliveryAgentsByIdReducer(state = initialState, action) {
  switch (action.type) {
   
    case GET_DELIVERY_AGENTS_BY_ID_DATA_LOADING:
      return { ...state, getDeliveryAgentsById: { ...state.getDeliveryAgentsById, loading: true, error: false, errors: [], success: false } };

    case GET_DELIVERY_AGENTS_BY_ID_DATA_SUCCESS:
      return { ...state, getDeliveryAgentsById: { ...state.getDeliveryAgentsById, loading: false, error: false, errors: [], success: true, data: action.response.data } };

    case GET_DELIVERY_AGENTS_BY_ID__DATA_ERROR:
      return { ...state, getDeliveryAgentsById: { ...state.getDeliveryAgentsById, loading: false, error: true, errors: action.errors, success: false, data: null } };

    case RESET_GET_DELIVERY_BY_ID_AGENTS_DATA_SUCCESS:
      return { ...state, getDeliveryAgentsById: { ...state.getDeliveryAgentsById, loading: false, error: false, errors: null, success: false } }

    default:
      return state;
  }
}
